import { Dispatch, FC, FormEvent, SetStateAction } from 'react';
import { AllowListFilter, searchLabels, UserSearchBarOptions } from '#types';
import { useSafeState } from '#hooks';

interface AllowListSearchBarProps {
    setFilter: Dispatch<SetStateAction<AllowListFilter>>;
    setCurrentPage: (currentPage: number) => void;
}

export const AllowListSearchBar: FC<AllowListSearchBarProps> = ({ setFilter, setCurrentPage }) => {
    const [searchQuery, setSearchQuery] = useSafeState<string>('');
    const [searchField, setSearchField] = useSafeState<string>(UserSearchBarOptions.EMAIL);
    const userSearchBarOptionLabels: searchLabels[] = [
        { value: UserSearchBarOptions.EMAIL, label: "Email" },
    ];

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setFilter({ email: searchQuery });
        setCurrentPage(1);
    };

    const handleClearFilter = () => {
        setFilter({})
        setCurrentPage(1)
    }

    return <div className='search-bar'>
        <form onSubmit={handleSubmit} id='user-search-bar-container'>
            <div className='two-columns-expand-two'>
                <label htmlFor="search-query" className='vertical-align mr-m'>Search:</label>
                <input
                    type="text"
                    id="search-query"
                    className='pl-m'
                    value={searchQuery}
                    onChange={(event) => setSearchQuery(event.target.value)}
                />
            </div>
            <div className='four-columns-auto'>
                <label htmlFor="search-field" className='vertical-align ml-m mr-m nowrap'>Search by:</label>
                <div className='three-rows-expand-one-three'>
                    <div />
                    <select id="search-field" value={searchField} onChange={(event) => setSearchField(event.target.value)}>
                        {
                            Object.values(userSearchBarOptionLabels).map(
                                (searchBarOption) => <option value={searchBarOption.value} key={searchBarOption.value}>
                                    {searchBarOption.label}
                                </option>
                            )
                        }
                    </select>
                    <div />
                </div>
                <button type="submit" className='searchBy-btn bold white-text'>SEARCH</button>
                <button type="button" onClick={handleClearFilter} className='searchBy-btn white-text bold nowrap'>CLEAR</button>
            </div>
        </form>
    </div>
};
